import { Box, ChevronRightIcon, Flex, Link, Text } from '~/design-system';
import CompanyLogo from '../CompanyLogo';
// import useLink from '../useLink';

export default function CompaniesListItem({ company, onSelectCompany }) {
  // const link = useLink();
  return (
    <Link
      variant="text"
      onClick={() => onSelectCompany(company)}
      // to={link.confirmJoinCompany({
      //   workspaceId: company.brandId,
      // })}
    >
      <Flex
        align="center"
        sx={{
          // Why does alignItems have to be set?
          // align="center" isn't working
          alignItems: 'center',
          paddingLeft: 3,
          paddingRight: 1,
          borderBottom: 1,
          borderColor: 'border',
          minHeight: 74,
          color: 'black',
          ':hover': {
            backgroundColor: 'light',
            textDecoration: 'none',
          },
        }}
      >
        <Box sx={{ width: 80, marginRight: 2 }}>
          <CompanyLogo company={company} />
        </Box>
        <Flex sx={{ flexGrow: 1 }}>
          <Text>{company.name}</Text>
        </Flex>
        <ChevronRightIcon sx={{ marginRight: 3 }} />
      </Flex>
    </Link>
  );
}
